import React from "react";
import { useParams } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";

/**
 * Placeholder for a page whose backend/frontend hasn't been migrated yet.
 * digicampusbd's own PageController served every page through one generic
 * `/{pageUrl}` route; this is the same idea on the frontend — the sidebar is
 * fully data-driven from GET /api/menu today, and future migration phases
 * register the real component for a url in pageRegistry.js instead of this.
 */
export default function NotYetMigrated() {
  const { pageUrl } = useParams();
  return (
    <MainLayout>
      <h1>Coming soon</h1>
      <p>
        The <code>{pageUrl}</code> page hasn&apos;t been migrated to this new frontend yet — see{" "}
        <code>digicampus/MIGRATION.md</code> for the module-by-module plan.
      </p>
    </MainLayout>
  );
}
